import React, { useRef, useState } from 'react';

import validate from '../validators/validateText';

const QuestionFormTextArea = ({ focus, question, savedAnswer, onChange, children }) => {
  const [text, setText] = useState(savedAnswer || '');
  const inputRef = useRef(null);

  const handleChange = event => {
    setText(event.target.value);
    onChange(question.key, event.target.value, validate);
  };

  return (
    <div>
      <div className="field">
        <div className="control">
          <textarea ref={inputRef} className="input" style={{ height: 150 }} autoFocus={focus} onChange={handleChange} maxLength={(question.maxLength) ? question.maxLength : 524288}>
            {text}
          </textarea>
        </div>
      </div>
      {children}
    </div>
  );
};

export default QuestionFormTextArea;
